import React from 'react'
import { Link } from "react-router-dom";

const SolarWaterHeaterSolution = () => {
  return (
    <>
      <div className="site-breadcrumb" style={{ background: 'url(assets/yog/0101.webp)' }}>
        <div className="container">
          <h2 className="breadcrumb-title">Solar Water Heater Solution</h2>
          <ul className="breadcrumb-menu">
            <li><Link to="/">Home</Link></li>
            <li className="active"><b>Solar Water Heater Solution</b></li>
          </ul>
        </div>
      </div>
      <div className="service-single py-120" style={{ marginTop: "-80px" }}>
        <div className="container">
          <div className="service-single-wrap">
            <div className="row">

              <div className="col-xl-4 col-lg-4">
                <div className="service-sidebar">
                  <div className="widget">
                    <h4 className="title">All Services</h4>
                    <div className="category">
                      <Link to="/solar-water-heater-solution"><i className="far fa-angle-double-right" /><b>Solar Water Heater Solution</b></Link>
                      <Link to="/solar-electrical-installation"><i className="far fa-angle-double-right" /><b>Solar & Electrical Installation</b></Link>
                      <Link to="/on-grid-off-grid-solar"><i className="far fa-angle-double-right" /><b>On-Grid & Off-Grid Solar</b></Link>
                      <Link to="/hybrid-solar-power-plant"><i className="far fa-angle-double-right" /><b>Hybrid Solar Power Plant</b></Link>
                      <Link to="/EV-charging-solution"><i className="far fa-angle-double-right" /><b>EV Charging Solution</b></Link>
                      <Link to="/energy-efficient-building"><i className="far fa-angle-double-right" /><b>Energy Efficient Building</b></Link>
                      <Link to="/solar-water-pump-solution"><i className="far fa-angle-double-right" /><b>Solar Water Pump Solution</b></Link>
                    </div>
                  </div>
                  {/* <div className="widget">
                    <h4 className="title">Download</h4>
                    <div className="service-download">
                      <a to="#"><i className="far fa-file-pdf" /> Download Brochure</a>
                      <a to="#"><i className="far fa-file-alt" /> Download Application</a>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="col-xl-8 col-lg-8">
                <div className="service-details">
                  <div className="mb-30">
                    <img src="assets/yog/Solar.webp" alt="thumb" />
                  </div>
                  <div className="content">
                    <h3 className="mb-20">Solar Water Heater Solution – Yogesh Solar Energy</h3>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      Harness the power of the sun and enjoy hot water all year round with Yogesh Solar Energy’s Solar Water Heater Solutions. Designed for efficiency, durability, and cost savings, our systems provide an eco-friendly alternative to traditional water heating methods.
                    </p>
                    <h3 className="mb-20">Our Solar Water Heater Services</h3>
                    <p className="mb-20" style={{ textAlign: "justify" }}>
                      At Yogesh Solar Energy, we offer end-to-end solutions tailored to your needs:
                    </p>
                    {/* <div className="row">
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/01.jpg" alt />
                      </div>
                      <div className="col-md-6 mb-20">
                        <img src="assets/img/service/02.jpg" alt />
                      </div>
                    </div> */}
                    <div className="my-4">
                      <div className="mb-3">
                      </div>
                      <ul className="list">
                        <li><i className="far fa-check-double" /> Residential Solar Water Heater Installation</li>
                        <li><i className="far fa-check-double" /> Commercial & Industrial Hot Water Solutions</li>
                        <li><i className="far fa-check-double" /> Customized System Design</li>
                        <li><i className="far fa-check-double" /> Repair & Maintenance Services</li>
                        <li><i className="far fa-check-double" /> System Upgradation & Replacement</li>
                      </ul>
                      <h3 className="mb-20">Why Choose Solar Water Heating?</h3>
                      <p className="mb-20" style={{ textAlign: "justify" }}>
                        Switching to solar water heaters comes with multiple benefits:
                      </p>
                      <li> 💰 Significant Cost Savings – Reduce electricity and gas bills</li>
                      <li> 🌱 Eco-Friendly – Clean, renewable energy with zero emissions</li>
                      <li> 🔥 Consistent Hot Water Supply – Even during power cuts</li>
                      <li> 🛠️ Low Maintenance – Long-lasting systems with minimal upkeep</li>
                      <li> 📈 High Return on Investment – Recover cost within a few years</li>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>



    </>
  )
}

export default SolarWaterHeaterSolution